$("[rel=popover]").popover({
	container: "body",
});
$("[title]:not([rel=popover])").tooltip();

// wandelt z.B. 14011996 in 14.01.1996 um
const $stringToDate = $(".stringtodate");
if ($stringToDate.length > 0) {
	$stringToDate.stringToDate();
}
